export const localization = {
  en: {
    appointments: 'Appointments',
    upcoming: 'Upcoming',
    past: 'Past',
    yourVisitWith: 'Your visit with',
    noData: 'No Data',
    noDataAvailable: 'No Data Available',
    call: 'Call',
    sendMessage: 'Send Message',
    appointmentLocation: 'Appointment Location',
    getDirections: 'Get Directions',
    beforeYouComeIn: 'Before your visit',
    unavailableMessage: "Information may be unavailable due to patient's age. ",
    learnMore: 'Learn more.',
    noUpcomingAppointment: 'No Upcoming Visits',
    checkin: 'Time to Check In',
    startedCheckin: 'Continue Check-In',
    completedCheckin: 'Check In Completed',
    checkinText: 'Check-In',
    noPastAppointment: 'No Past Visits',
    error: 'Something went wrong',
    errorAppointmentsTitle: 'Something went wrong...',
    errorAppointmentsSubtitle: 'Try again later. If the error persist please',
    errorAppointmentsLinkText: 'contact support',
    errorLoadMoreMessage: "Couldn't load more appointments",
    errorRetry: 'Retry',
    telehealthText: 'This is a telehealth appointment.',
    joinIn: 'Click here to start',
    download: 'download',
    addToCalendar: 'Add to calendar',
    errorSubtitle: 'Please try again later.',
    icsErrorInvalidTitle: "We couldn't download this calendar file",
    icsErrorInvalidSubtitle:
      'Some appointment details are missing or invalid. Please refresh the page and try again.',
    icsErrorDownloadTitle: 'Calendar file download blocked',
    icsErrorDownloadSubtitle:
      'Your browser blocked the calendar file download. Please check your browser settings and try again.',
    icsSuccessSubtitle:
      'Your appointment .ics file was downloaded successfully, please open it to add it to your calendar.'
  },
  es: {
    appointments: 'Citas',
    upcoming: 'Próximas',
    past: 'Pasadas',
    yourVisitWith: 'Su consulta con',
    noData: 'Sin datos',
    noDataAvailable: 'No hay datos disponibles',
    call: 'Llamar',
    sendMessage: 'Enviar mensaje',
    appointmentLocation: 'Ubicación de la cita',
    getDirections: 'Obtener indicaciones',
    beforeYouComeIn: 'Antes de su visita',
    unavailableMessage:
      'La información puede no estar disponible debido a la edad del paciente. ',
    learnMore: 'Aprende más.',
    noUpcomingAppointment: 'No tiene citas futuras',
    checkin: 'Hora de registrarse',
    startedCheckin: 'Continuar con el registro',
    completedCheckin: 'Registro completado',
    checkinText: 'Registro',
    noPastAppointment: 'No tiene citas pasadas',
    error: 'Ha ocurrido un error',
    errorAppointmentsTitle: 'Algo salió mal...',
    errorAppointmentsSubtitle:
      'Inténtalo de nuevo más tarde. Si el error persiste, por favor',
    errorAppointmentsLinkText: 'contacta a soporte',
    errorLoadMoreMessage: 'No se pudieron cargar más citas',
    errorRetry: 'Reintentar',
    telehealthText: 'Esta es una cita de telesalud.',
    joinIn: 'Haz clic para iniciar',
    download: 'Descargar',
    addToCalendar: 'Agregar al calendario',
    errorSubtitle: 'Por favor, inténtelo de nuevo más tarde.',
    icsErrorInvalidTitle: 'No pudimos decargar este archivo de calendario',
    icsErrorInvalidSubtitle:
      'Faltan algunos datos de la cita o no son válidos. Por favor, actualice la página e inténtelo de nuevo.',
    icsErrorDownloadTitle: 'Descarga del archivo de calendario bloqueada',
    icsErrorDownloadSubtitle:
      'Su navegador bloqueó la descarga del archivo de calendario. Por favor, revise la configuración de su navegador e inténtelo de nuevo.',
    icsSuccessSubtitle:
      'El archivo .ics de tu cita se descargó correctamente, ábrelo para añadirlo a tu calendario.'
  },
  /* eslint-disable no-secrets/no-secrets */
  keyMapping: {
    appointments: 'UFD_Appointments_Button',
    upcoming: 'UFD_Upcoming_Label',
    past: 'UFD_Past_Label',
    yourVisitWith: 'UFD_Your_visit_with_Text',
    noData: 'UFD_No_Upcoming_Visit',
    call: 'UFD_Appt_Call_Button',
    sendMessage: 'UFD_Appt_Send_Message',
    appointmentLocation: 'UFD_Appt_Location',
    getDirections: 'UFD_Get_Directions_Text',
    beforeYouComeIn: 'UFD_Appt_Before_Visit',
    noUpcomingAppointment: 'UFD_No_Upcoming_Visit',
    checkin: 'UFD_Time_To_Check_In',
    completedCheckin: 'UFD_Check_In_Completed',
    checkinText: 'UFD_Check_In_Label',
    noPastAppointment: 'UFD_No_Past_Visits',
    error: 'UFD_Error_Text',
    telehealthText: 'UFD_Telehealth_Text',
    noDataAvailable: 'UFD_No_Data_Text',
    unavailableMessage: 'UFD_Adolescent_Proxy_Disclaimer',
    learnMore: 'UFD_Appt_Learn_More',
    startedCheckin: 'UFD_Continue_Check_In',
    joinIn: 'UFD_Appointment_Join_In_Label',
    download: 'UFD_Download_Button',
    icsSuccessSubtitle: 'UFD_Appointment_Ics_Success_Subtitle',
    errorAppointmentsTitle: 'UFD_Appointments_Error_Title',
    errorAppointmentsSubtitle: 'UFD_Appointments_Error_Subtitle',
    errorAppointmentsLinkText: 'UFD_Appointments_Error_Link_Text',
    errorLoadMoreMessage: 'UFD_Appointments_Load_More_Error',
    errorRetry: 'UFD_Retry_Button'
  }
  /* eslint-disable no-secrets/no-secrets */
}
